import { GameScreen } from './components/GameScreen'
import { Lobby } from './components/Lobby'
import { Setup } from './components/Setup'
import { useGame } from './store/gameStore'

export default function App() {
  const g = useGame((s) => s.g)
  const mode = useGame((s) => s.mode)
  const connecting = useGame((s) => s.net.status !== 'idle')

  if (g) return <GameScreen g={g} />
  if (mode === 'online' && connecting) return <Lobby />
  return <Setup />
}
